import { Validator } from "../../../TOOLS/Validator";
import { FormController } from "./FormController";

export class UserForm {

    constructor(store) {
        this.store = store;
        this.validator = new Validator(this.store);
        this.formController = new FormController(this.store, this.validator)
        this.data = this.store.level.selectedColleague ?? {};
        this.FIELD_CONFIG = {
            name: { type: "text" },
            email: { type: "text" },
            inventory: {
                type: "checkbox",
                toData: checked => checked ? "active" : "inactive"
            },
            role: {
                type: "checkbox",
                toData: checked => checked ? "active" : "inactive"
            },
            job: {
                type: "job",
                toData: checked => checked ? "HO" : "FG"
            },
            officeid: {
                type: "officeid",
                toData: value => Number(value)
            }
        };
        this.excludedFields = [
            "id",
            "firestoreid",
            "picture",
            "district",
            "districtid",
            "token",
            "tokentimestamp",
        ];
        this.keyChange = {
            job: "Beosztás",
            role: "Aktív munkavállaló",
            office: "Iroda",
            inventory: "Leltárállapot",
            phone: "Telefonszám",
            name: "Név",
        };
        this.container = document.createElement("div");
        this.container.className = 'width-100 height-100';
        this.container.id = 'USERFORM MAIN';
        this.officeName = null;
   }

    async render() {
        await this.store.datas.load('CITIES');
        let cities = this.store.database.cities.filter((city => city.district === this.store.level.selectedDistrict));
        await this.buildRolldowns(cities)
        this.container.innerHTML = "";
        const title = document.createElement("div");
        title.textContent = this.store.level.selectedColleague.name;
        title.className = "font-35 weight-600";
        const form = document.createElement("form");
        form.className = "sectionColumn";
        form.id = 'FORMSECTION'
        Object.entries(this.data)
        .filter(([key]) => {
            if (!this.excludedFields.includes(key)) {return true;}
            return false;
        })
        .forEach(([key, value]) => {
            const row = document.createElement("div");
            row.className = "list-row";
            const label = document.createElement("label");
            label.textContent = this.keyChange[key] ?? key;
            row.appendChild(label);
            row.appendChild(this.createField(key, value));
            form.appendChild(row);
        });

        const button = document.createElement("div");
        button.className = 'width-100 justify-center margin-top-2 login-button'
        button.type = "submit";
        this.bindItemEvents(button, form);
        form.appendChild(button);
        this.container.appendChild(title);
        this.container.appendChild(form);
        return this.container;
        
    }

    bindItemEvents(button, form) {
        button.addEventListener("click", async (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.formController.bindSubmit(form, {
                getData: this.getData.bind(this),
                complete: this.complete.bind(this),
                process: "MODIFY",
                formType: 'USER',
                original: this.store.level.selectedColleague === null ? this.getData(form) : this.store.level.selectedColleague,
                actiontype: "MODIFY",
                reference: "USERS",
                onSuccess: async (response) => {this.store.levelController.setLevel({name: "MAP", office: null, position: null});
                console.log('RESP', response)
                    this.store.toast.success(response);
                }
            });
            form.requestSubmit();
        });
    }

    async buildRolldowns(cities) {this.officeRolldown = await this.store.datas.getOfficeRolldownByDistrict(this.store.level.selectedDistrict)}

    createField(key, value) {
        const config = this.FIELD_CONFIG[key] ?? { type: "text" };
        switch (config.type) {
            case "checkbox": {
                const input = document.createElement("input");
                input.type = "checkbox";
                input.className = 'form-input'
                input.name = key;
                input.id = `${key}-switch`;
                input.checked = value === "active";
                const wrapper = document.createElement("div");
                wrapper.className = "job-switch-wrapper";
                const left = document.createElement("span");
                left.className = "job-label";
                left.textContent = "INAKTÍV";
                const switchLabel = document.createElement("label");
                switchLabel.className = "switch";
                const slider = document.createElement("span");
                slider.className = "slider";
                switchLabel.appendChild(input);
                switchLabel.appendChild(slider);
                const right = document.createElement("span");
                right.className = "job-label";
                right.textContent = "AKTÍV";
                wrapper.appendChild(left);
                wrapper.appendChild(switchLabel);
                wrapper.appendChild(right);
                return wrapper;
            }
             case "job": {
                const input = document.createElement("input");
                input.type = "checkbox";
                input.className = 'form-input'
                input.name = key;
                input.id = `${key}-switch`;
                input.checked = value === "active";
                const wrapper = document.createElement("div");
                wrapper.className = "job-switch-wrapper";
                const left = document.createElement("span");
                left.className = "job-label";
                left.textContent = "IRODAI DOLGOZÓ";
                const switchLabel = document.createElement("label");
                switchLabel.className = "switch";
                const slider = document.createElement("span");
                slider.className = "slider";
                switchLabel.appendChild(input);
                switchLabel.appendChild(slider);
                const right = document.createElement("span");
                right.className = "job-label";
                right.textContent = "FALUGAZDÁSZ";
                wrapper.appendChild(left);
                wrapper.appendChild(switchLabel);
                wrapper.appendChild(right);
                return wrapper;
            }
            case "select": {
                const select = document.createElement("select");
                select.className = 'form-input'
                select.name = key;
                config.options.forEach(option => {
                    const opt = document.createElement("option");
                    opt.value = option;
                    opt.textContent = option;
                    if (option === value) {opt.selected = true;}
                    select.appendChild(opt);
                });
                return select;
            }
            case "number": {
                const input = document.createElement("input");
                input.className = 'form-input'
                input.type = "number";
                input.name = key;
                input.value = value ?? "";
                return input;
            }
            case "officeid": {
                const select = document.createElement("select");
                select.className = 'form-input'
                select.name = key;
                select.addEventListener("change", () => {this.selectedOffice = Number(select.value);});
                this.officeRolldown.forEach(office => {
                    const option = document.createElement("option");
                    option.value = office.officeid;
                    option.textContent = office.name;
                    //KIVÁLASZTJA AZ OFFICEROLLDOWN CITY OBJEKTUMAI KÖZÜL AZT, AMINEK AZ OFFICEID-JE MEGYEGYERIK A SELECTEDCOLLEAGUE OFFICEID-VEL
                    if (Number(office.officeid) === Number(this.store.level.selectedColleague.officeid)) {option.selected = true;}
                    select.appendChild(option);
                });
                return select;
            }
            default: {
                const input = document.createElement("input");
                input.className = 'form-input'
                input.type = "text";
                input.name = key;
                input.value = value ?? "";
                return input;
            }
        }
    }

    getData(form) {
    const result = {};

    Object.entries(this.data)
        .filter(([key]) => !this.excludedFields.includes(key))
        .forEach(([key]) => {
            const config = this.FIELD_CONFIG[key] ?? { type: "text" };
            const input = form.elements[key];
            let value;
            switch (config.type) {
                case "checkbox":
                case "job":
                    value = input.checked;
                    break;
                case "number":
                case "officeid":
                    value = input.value;
                    break;
                default:
                    value = input.value;
            }
            result[key] = config.toData ? config.toData(value) : value;
        });

    return result;
}

    complete(form) {
        form.id = this.store.level.selectedColleague.id
        form.firestoreid = this.store.level.selectedColleague.firestoreid
        form.picture = this.store.level.selectedColleague.picture
        form.districtid = this.store.level.selectedColleague.districtid
        form.inventory = this.store.level.selectedColleague.inventory
        form.token = this.store.level.selectedColleague.token
        form.tokentimestamp = this.store.level.selectedColleague.tokentimestamp
        
        return form   
    }

}